import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetLink = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full stroke-current fill-transparent"
    >
      <path
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M23.047 17.953a6.667 6.667 0 0 0-9.428 0l-6.666 6.666a6.667 6.667 0 0 0 9.428 9.428l1.836-1.836m-1.264-8.164a6.667 6.667 0 0 0 9.428 0l6.666-6.666a6.667 6.667 0 1 0-9.428-9.428l-1.832 1.832"
      />
    </svg>,
  );

IconWidgetLink.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetLink;
